import React from "react";
import { Box, Typography } from "@mui/material";
import Statics from "./statics";
import useStyles from "./Styles";

const ChatStatics: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box id="tour-dashboard-chat-statistics" className={classes.gridItems}>
      <Typography className={classes.headText}>Chat Statistics</Typography>
      <Statics />
    </Box>
  );
};

export default ChatStatics;
